var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChecked = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4126 0.420945L6.24017 8.1857L2.65413 4.46892C2.26654 4.05299 1.69258 3.88619 1.15285 4.03261C0.613126 4.17903 0.191623 4.6159 0.0503495 5.17531C-0.0909241 5.73471 0.0700173 6.32959 0.471316 6.73131L5.10245 11.5313C5.68692 12.1372 6.62814 12.1583 7.23741 11.5793L16.4997 2.77933C16.9062 2.39292 17.0828 1.8111 16.9632 1.25305C16.8436 0.694995 16.4458 0.245489 15.9197 0.0738535C15.3935 -0.0977821 14.8191 0.0345283 14.4126 0.420945Z",
    fill: "currentcolor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChecked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checked.67d093359f8ea48dc85f3125e9e6b659.svg";